import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { ScreenDepth } from "@ryde/theme";

export const IsReadBase = styled.input.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "is-read-base",
})`
  cursor: inherit;
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  z-index: ${ScreenDepth.HIDDEN_INPUTS};
`;

export const IsReadStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "is-read",
})`
  padding: 12px;
`;
